"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _get = _interopRequireDefault(require("./get"));

var _isParentValue = _interopRequireDefault(require("./isParentValue"));

var _prepareChildKeys = _interopRequireDefault(require("./prepareChildKeys"));

var _keyOrIndexToProperty = _interopRequireDefault(require("./keyOrIndexToProperty"));

var _updateChild = _interopRequireDefault(require("./updateChild"));

var _updateChildKeys = _interopRequireDefault(require("./updateChildKeys"));

var _set = _interopRequireDefault(require("unmutable/lib/set"));

var _update = _interopRequireDefault(require("unmutable/lib/update"));

var _pipeWith = _interopRequireDefault(require("unmutable/lib/util/pipeWith"));

var _default = function _default(key, updater) {
  return function (parcelData) {
    var parcelDataWithChildKeys = (0, _prepareChildKeys["default"])()(parcelData);
    var property = (0, _keyOrIndexToProperty["default"])(key)(parcelDataWithChildKeys);

    if (typeof property === "undefined") {
      return parcelDataWithChildKeys;
    }

    var updatedData = (0, _pipeWith["default"])(parcelDataWithChildKeys, (0, _get["default"])(key), updater);
    var updatedValue = updatedData.value,
        updatedChild = updatedData.child,
        updatedChildValues = (0, _objectWithoutProperties2["default"])(updatedData, ["value", "child"]);
    var value = (0, _pipeWith["default"])(parcelDataWithChildKeys.value, (0, _set["default"])(property, updatedValue));
    var child = (0, _pipeWith["default"])(parcelDataWithChildKeys.child, (0, _update["default"])(property, function (node) {
      return (0, _objectSpread2["default"])({}, node, {
        child: updatedChild
      }, updatedChildValues);
    }));
    var result = (0, _objectSpread2["default"])({}, parcelDataWithChildKeys, {
      value: value,
      child: child
    });

    if ((0, _isParentValue["default"])(result.value)) {
      return (0, _pipeWith["default"])(result, (0, _updateChild["default"])(), (0, _updateChildKeys["default"])());
    }

    return result;
  };
};

exports["default"] = _default;